import React from 'react';
import { PATHS } from './paths';
import { BookmarkIcon, HeartIcon, UserIcon, PenIcon, WlasWidgetIcon } from '@/components';

export const PROFILE_NAV_BAR = [
  {
    title: PATHS.DASHBOARD,
    icon: <UserIcon />,
  },
  {
    title: PATHS.MEMBER_PROFILE,
    icon: <PenIcon />,
  },
  {
    title: PATHS.WLAS_WIDGET,
    icon: <WlasWidgetIcon />,
    hiddenInProd: true,
  },
  {
    title: PATHS.WATCH_LIST,
    icon: <HeartIcon width={20} height={20} />,
  },
  {
    title: PATHS.SEARCH_PROFILE,
    icon: <BookmarkIcon width={20} height={20} />,
  },
] as { title: string; icon: React.ReactNode; hiddenInProd?: boolean }[];
